module.exports = __webpack_public_path__ + "img/ent1.a5b460d6.png";